import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { MdFormatUnderlined } from "react-icons/md";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { activeButtonStyle, buttonStyle } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonUnderlineProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonUnderline = ({ className, children }: TextEditorMenuButtonUnderlineProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  const buttonClassName = editor && editor.isActive("underline") ? activeButtonStyle : buttonStyle;

  return (
    <Tooltip content={t("buttons.underline")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().focus().toggleUnderline().run();
          }
        }}
        className={twMerge(buttonClassName, className)}
        disabled={disabled}
      >
        {children ?? <MdFormatUnderlined className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
